import axios from 'axios';

const getToken = () => {
    let token = localStorage.getItem("token") || null
    return token ? token : ""
}


// Default config options
export const defaultOptions = {
    withCredentials: false,
    headers: {
        Accept: '*/*',
        "Content-Type": 'application/json'
    },
};



// Create instance
const server = axios.create({
    baseURL: "https://api.womenses.com/v1",
    // baseURL: "http://localhost:4500/v1",
    timeout: 100000,
    ...defaultOptions
});

export async function authorizeMe(token) {
    server.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

server.interceptors.response.use(function (response) {
    response.headers.Authorization = `Bearer ${getToken()}`
    return response;
}, function (error) {
    if (error?.response?.status === 500) {
        toast.error("Interal server error")
    }
    if (error?.response?.status === 401) {
        onLogout();
    }
    return Promise.reject(error);
});

const onLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
    window.location.assign('/')
}

export { server };